/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PortfolioDto } from '../../models/portfolio-dto';

export interface PortfolioClientControllerFindByIdV1$Params {
  id: string;
}

export function portfolioClientControllerFindByIdV1(http: HttpClient, rootUrl: string, params: PortfolioClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioDto>> {
  const rb = new RequestBuilder(rootUrl, portfolioClientControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PortfolioDto>;
    })
  );
}

portfolioClientControllerFindByIdV1.PATH = '/api/v1/portfolios/client/{id}';
